<div class="w-full h-full flex flex-col gap-2">
  <div class="flex items-center gap-8">
    <wj-group-panel
      *ngIf="options.showGroupPanel"
      [grid]="grid"
      placeholder="Arraste colunas aqui para agrupar">
    </wj-group-panel>

    <wj-flex-grid-search
      *ngIf="options?.showSearch"
      [grid]="grid"
      [delay]="150"
      [cssMatch]="'wj-state-match'"
      [placeholder]="'Pesquisar...'">
    </wj-flex-grid-search>

    <div class="ml-auto flex gap-8">
      <button type="button" (click)="exportXlsx()">XLSX</button>
      <button type="button" (click)="exportCsv()">CSV</button>
      <button type="button" (click)="exportPdf()">PDF</button>
      <button type="button" (click)="resetLayout()">Resetar layout</button>
      <div style="font-size: 13px; color: #555; display: flex; align-items: center">
        {{ (cv?.items?.length || 0) | numeralFormat }} de {{ (items?.length || 0) | numeralFormat }} itens
      </div>
    </div>
  </div>

  <wj-flex-grid
    #gridRef
    class="flex-1"
    [itemsSource]="cv"
    [allowSorting]="options?.allowSorting"
    [allowPinning]="options?.allowSorting"
    [frozenColumns]="frozenColumns"
    [autoGenerateColumns]="false"
    [isReadOnly]="options?.isReadOnly"
    (cellEditEnded)="cellEditEnded($event)"
    (initialized)="onGridInit(gridRef)"
    (sortedColumn)="saveLayout('sortedColumn')"
    (draggedColumn)="saveLayout('draggedColumn')"
    (resizedColumn)="saveLayout('resizedColumn')"
    (rowEditEnded)="saveLayout('rowEditEnded')"
    (updatedLayout)="saveLayout('updatedLayout')"
    (groupCollapsedChanged)="saveLayout('groupCollapsedChanged')"
    (loadedRows)="onLoadedRows()"
  >
    <wj-flex-grid-filter (filterChanged)="filterChange($event)" (initialized)="initFilter(gridRefFilter)"
                         #gridRefFilter/>
    <!-- Colunas são geradas dinamicamente no TS -->
  </wj-flex-grid>

  @for (column of this.columnsMultiselect; track column.key; ) {
      <wj-multi-select
        [itemsSource]="column.value"
        [id]="'multiSelect'+column.key" [showSelectAllCheckbox]="true"></wj-multi-select>
  }
</div>
